import Storage from "react-native-storage";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IS_WEB, replaceAll } from "./common";

const storage = !IS_WEB
  ? new Storage({
      // 最大容量，默认值1000条数据循环存储
      size: 1000,

      // 存储引擎：对于RN使用AsyncStorage，对于web使用window.localStorage
      // 如果不指定则数据只会保存在内存中，重启后即丢失
      storageBackend: AsyncStorage,

      // 数据过期时间，默认一整天（1000 * 3600 * 24 毫秒），设为null则永不过期
      defaultExpires: null,

      // 读写时在内存中缓存数据。默认启用。
      enableCache: true,

      // 如果storage中没有相应数据，或数据已过期，
      // 则会调用相应的sync方法，无缝返回最新数据。
      // sync方法的具体说明会在后文提到
      // 你可以在构造函数这里就写好sync的方法
      // 或是在任何时候，直接对storage.sync进行赋值修改
      // 或是写到另一个文件里，这里require引入
      sync: {},
    })
  : null;

export default {
  save: <T>(key: string, data: T) => {
    if (!storage) return Promise.resolve(undefined);
    //key中不能存在 "_"
    if (key?.includes("_")) {
      console.info("save-key====>", key);
      if (!__DEV__) {
        key = replaceAll(key, "_", "-");
      }
    }
    const resultPromise = new Promise((resolve, reject) => {
      storage
        .save({
          key: key,
          data: data,
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          if (__DEV__) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            reject(err);
          } else {
            resolve(undefined);
          }
        });
    });
    return resultPromise;
  },
  load: <T>(key: string): Promise<T | undefined> => {
    if (!storage) return Promise.resolve(undefined);
    //key中不能存在 "_"
    if (key?.includes("_")) {
      console.info("load-key====>", key);
      if (!__DEV__) {
        key = replaceAll(key, "_", "-");
      }
    }
    const resultPromise = new Promise<T | undefined>((resolve, reject) => {
      storage
        .load({
          key: key,
          // autoSync(默认为true)意味着在没有找到数据或数据过期时自动调用相应的sync方法
          autoSync: true,
          // syncInBackground(默认为true)意味着如果数据过期，
          // 在调用sync方法的同时先返回已经过期的数据。
          // 设置为false的话，则等待sync方法提供的最新数据(当然会需要更多时间)。
          syncInBackground: true,
          // 你还可以给sync方法传递额外的参数
          syncParams: null,
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          if (__DEV__) {
            if (err && err.name == "NotFoundError") {
              resolve(undefined);
            } else {
              // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
              reject(err);
            }
          } else {
            resolve(undefined);
          }
        });
    });
    return resultPromise;
  },
  remove: (key: string) => {
    if (!storage) return Promise.resolve(undefined);
    const promise = new Promise((resolve, reject) => {
      storage
        .remove({
          key: key,
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          if (__DEV__) {
            // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
            reject(err);
          } else {
            resolve(undefined);
          }
        });
    });
    return promise;
  },
  // clear: () => {
  //   const promise = new Promise((resolve, reject) => {
  //     storage
  //       .clearMap()
  //       .then(response => {
  //         resolve(response);
  //       })
  //       .catch(err => {
  //         if (__DEV__) {
  //           reject(err);
  //         } else {
  //           resolve(undefined);
  //         }
  //       });
  //   });
  //   return promise;
  // },
};
